var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { Dimensions, Platform, View, Image as ReactImage } from 'react-native';
import { Image } from 'expo-image';
import { component } from '../../Decorators/Component';
import { CoreConfig } from '../../../CoreConfig';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { ICachedImageViewModelType } from './ICachedImageViewModel';
let CachedImageComponent = class CachedImageComponent extends Component {
    constructor(props) {
        super(props);
        this.onRef = this.onRef.bind(this);
        this.loadImage(props);
    }
    componentDidMount() {
        var _a, _b;
        Platform.OS === 'web' && ((_b = (_a = this.props).onLoadStart) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
    onSize(uri) {
        if (!this.props.onSize || !uri || typeof uri === 'number') {
            return;
        }
        ReactImage.getSize(uri, this.props.onSize, () => { });
    }
    loadImage(props) {
        var _a, _b, _c, _d, _e;
        this.uri = ((_a = props.viewModel) === null || _a === void 0 ? void 0 : _a.getImage(props.image)) || '';
        if (this.uri) {
            (_b = this.props.viewModel) === null || _b === void 0 ? void 0 : _b.setIsElementVisible(true);
            this.onSize(this.uri);
            if (typeof this.uri !== 'string') {
                (_c = props.onLoad) === null || _c === void 0 ? void 0 : _c.call(props);
            }
            else if (this.uri.toString().startsWith('data:')) {
                (_d = props.onLoad) === null || _d === void 0 ? void 0 : _d.call(props);
            }
        }
        else {
            this.onSize(props.image);
            (_e = props.onLoadStart) === null || _e === void 0 ? void 0 : _e.call(props);
            this.downloadImage(props.image, props.viewModel);
        }
    }
    downloadImage(image, viewModel) {
        return viewModel === null || viewModel === void 0 ? void 0 : viewModel.download(image).then(uri => {
            if (!this.isDestroyed) {
                this.uri = uri;
                this.forceUpdate();
            }
        }).catch(error => {
            var _a, _b;
            if (!this.isDestroyed) {
                (_b = (_a = this.props).onError) === null || _b === void 0 ? void 0 : _b.call(_a, error);
                this.forceUpdate();
            }
        });
    }
    onRef(ref) {
        var _a, _b, _c;
        if (!ref) {
            return;
        }
        if (this.uri) {
            return;
        }
        if (this.interval) {
            clearInterval(this.interval);
        }
        if (Platform.OS === 'web') {
            (_a = this.props.viewModel) === null || _a === void 0 ? void 0 : _a.setIsElementVisible(true);
            return;
        }
        if ((_b = this.props.viewModel) === null || _b === void 0 ? void 0 : _b.getIsDownloading(this.props.image)) {
            return;
        }
        if (ref === null || ref === void 0 ? void 0 : ref.getNode) {
            return this.onRef(ref === null || ref === void 0 ? void 0 : ref.getNode());
        }
        if (!(ref === null || ref === void 0 ? void 0 : ref.measure)) {
            (_c = this.props.viewModel) === null || _c === void 0 ? void 0 : _c.setIsElementVisible(true);
            return;
        }
        const measure = () => {
            return new Promise((res) => {
                var _a;
                if (!(ref === null || ref === void 0 ? void 0 : ref.measure)) {
                    clearInterval(this.interval);
                    this.interval = undefined;
                    (_a = this.props.viewModel) === null || _a === void 0 ? void 0 : _a.setIsElementVisible(true);
                    res(true);
                    return;
                }
                ref === null || ref === void 0 ? void 0 : ref.measure((x, y, width, height, pageX, pageY) => {
                    var _a, _b;
                    const values = [width, height, pageX, pageY];
                    if (values.findIndex(x => x === undefined) > -1) {
                        clearInterval(this.interval);
                        this.interval = undefined;
                        (_a = this.props.viewModel) === null || _a === void 0 ? void 0 : _a.setIsElementVisible(true);
                        res(true);
                        return;
                    }
                    const isVisible = this.getIsVisible(width || 0, height || 0, pageX || 0, pageY || 0);
                    if (isVisible) {
                        clearInterval(this.interval);
                        this.interval = undefined;
                        (_b = this.props.viewModel) === null || _b === void 0 ? void 0 : _b.setIsElementVisible(true);
                    }
                    res(isVisible);
                });
            });
        };
        measure().then(isVisible => {
            if (!isVisible) {
                this.interval = setInterval(() => {
                    if (this.isDestroyed) {
                        clearInterval(this.interval);
                        this.interval = undefined;
                        return;
                    }
                    if (this.uri) {
                        clearInterval(this.interval);
                        this.interval = undefined;
                        return;
                    }
                    measure();
                }, 100);
            }
        });
    }
    getIsVisible(width, height, pageX, pageY) {
        const window = Dimensions.get('window');
        return pageX + width > 0 &&
            pageX < window.width &&
            pageY + height > 0 &&
            pageY < window.height;
    }
    shouldComponentUpdate(nextProps) {
        nextProps.image !== this.props.image && this.loadImage(nextProps);
        return true;
    }
    componentWillUnmount() {
        this.isDestroyed = true;
        this.interval && clearInterval(this.interval);
    }
    render() {
        const { resizeMode, imageStyle, image, onLoad, onError, onLoadEnd, onLoadStart, blurRadius, color, fill } = this.props;
        if (!this.uri) {
            return _jsx(View, { ref: this.onRef });
        }
        if (!image.toString().endsWith('.svg')) {
            return _jsx(ReactImage, { source: typeof this.uri === 'number'
                    ? this.uri
                    : { uri: this.uri }, resizeMode: resizeMode || 'contain', style: imageStyle, onLoad: onLoad, onError: onError, onLoadEnd: onLoadEnd, onLoadStart: onLoadStart, blurRadius: blurRadius, tintColor: color || fill, ref: this.onRef });
        }
        return (_jsx(Image, { source: typeof this.uri === 'number'
                ? this.uri
                : { uri: this.uri }, contentFit: resizeMode || 'contain', style: imageStyle, onLoad: onLoad, onError: onError, onLoadEnd: onLoadEnd, onLoadStart: onLoadStart, blurRadius: blurRadius, tintColor: color || fill, ref: this.onRef }));
    }
};
CachedImageComponent = __decorate([
    component({
        provider: CoreConfig.provider,
        moduleName: CoreConfig.moduleName,
        componentName: Configuration.ComponentNames.cachedImage,
        dependencies: {
            viewModel: ICachedImageViewModelType
        }
    }),
    __metadata("design:paramtypes", [Object])
], CachedImageComponent);
export { CachedImageComponent };
